/* @flow */

import type { ThermostatRunModeFeature } from "./types";

export default function ThermostatRunMode(feature: ThermostatRunModeFeature) {
  let updateRunModeAction = feature.actions.update_thermostat_run_mode;

  this.setThermostatRunMode = (value) => {
    return this.executeDeviceAction(
      updateRunModeAction,
      {
        value,
      },
      { fetchModelWhenDone: true }
    );
  };

  return {
    thermostatRunMode: {
      name: feature.name,
      label: feature.label,
      options: feature.options,
      value: feature.value,
      displayValue: feature.display_value,
    },
  };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/thermostat_run_mode.js